/*
 * Copyright (C) 2014 Spanning Cloud Apps LLC.  All rights reserved.
 */
import './gdprRequestInfo.tpl.html';

angular
  .module('batch.gdprrequest.info', ['ngSanitize', 'services.view'])
  /**
   * Controller for the gdprrequest.info template.
   */
  .controller(
    'GdprRequestInfoCtrl',
    function (
      $scope,
      $filter,
      $state,
      $window,
      batchUtils,
      GdprRequestService,
      UserAgentFactory,
      progressFactory,
      ALERT_EVENTS,
      lastState,
      viewUtils,
      BATCH_RESULTS,
      VIEW_STATES
    ) {
      let batchDate;

      $scope.inProgress = false;

      /**
       * Utility function for returning to the previous state.
       */
      $scope.goBack = function () {
        viewUtils.resetState($state.current.name);
        $state.go(lastState || VIEW_STATES.ACCOUNT);
      };

      /**
       * Set the scope properties.
       */
      function updateInfo() {
        const jobType = $filter('i18n')($scope.batchUtils.currentBatch.type);
        $scope.operationType = $scope.batchUtils.currentBatch.gdprOperationType;
        $scope.boinkCls =
          $scope.batchUtils.currentBatch.status && batchUtils.STATUS[$scope.batchUtils.currentBatch.status]
            ? batchUtils.STATUS[$scope.batchUtils.currentBatch.status].bigBoinkCls
            : '';

        batchDate = moment($scope.batchUtils.currentBatch.date);
        $scope.batchDate = $filter('i18n')('BATCH_DETAIL_DATE', [
          batchDate.format(SBSF.messages.M_D_Y),
          batchDate.format(SBSF.messages.H_M),
          jobType
        ]);

        $scope.pctCls = function () {
          return $scope.batchUtils.currentBatch.status
            ? batchUtils.STATUS[$scope.batchUtils.currentBatch.status].textCls
            : '';
        };

        $scope.pctMsg = $filter('i18n')('PERCENT_PROTECTED', $scope.batchUtils.currentBatch.percentComplete);
      }

      // If a currentBatch is empty set redirect app to the admin view.
      if (_.isEmpty($scope.batchUtils.currentBatch)) {
        $scope.goBack();
      } else {
        updateInfo();
      }

      /**
       * Handler for the control to show and hide the error/warning messages.
       */
      $scope.toggleMessages = function () {
        $scope.$parent.showMessages = !$scope.$parent.showMessages;
      };

      $scope.performGdprRequest = function () {
        $scope.inProgress = true;
        return GdprRequestService.submitGdprRequest($scope.batchUtils.currentBatch.batchId).then(() => {
          $scope.goBack();
        });
      };

      /**
       * Handler for the control to show and hide the error/warning messages.
       */
      $scope.toggleMessages = function () {
        $scope.$parent.showMessages = !$scope.$parent.showMessages;
      };
    }
  );
